import * as KEYS from '@packages/utilities/key-utils';
import {type RadioSelectProps, type RadioSelectItem} from './RadioSelect.types';

const HOME = 36;
const END = 35;

function useRadioKeyboardEvents({
  // @ts-expect-error - TS7031 - Binding element 'items' implicitly has an 'any' type.
  items,
  // @ts-expect-error - TS7031 - Binding element 'selectedKey' implicitly has an 'any' type.
  selectedKey,
  // @ts-expect-error - TS7031 - Binding element 'onKeyDown' implicitly has an 'any' type.
  onKeyDown,
  // @ts-expect-error - TS7031 - Binding element 'onSelectItem' implicitly has an 'any' type.
  onSelectItem,
  loop = true,
}) {
  // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
  const currentItem = items.find((item) => item.key === selectedKey);
  const currentIndex = items.indexOf(currentItem);
  const itemsSize = items.length - 1;

  function first() {
    const nextItem = items[0].key;

    onSelectItem(nextItem);
  }

  function last() {
    const nextItem = items[itemsSize].key;

    onSelectItem(nextItem);
  }

  function next() {
    const bumpIndex = loop ? 0 : currentIndex;
    const nextKey = currentIndex === itemsSize ? bumpIndex : currentIndex + 1;
    const nextItem = items[nextKey].key;

    onSelectItem(nextItem);
  }

  function previous() {
    const bumpIndex = loop ? itemsSize : 0;
    const nextKey = currentIndex === 0 ? bumpIndex : currentIndex - 1;
    const nextItem = items[nextKey].key;

    onSelectItem(nextItem);
  }

  function handleOnKeyDown(event: KeyboardEvent) {
    switch (event.keyCode) {
      case KEYS.UP:
        event.preventDefault();
        previous();
        break;
      case KEYS.DOWN:
        event.preventDefault();
        next();
        break;

      case HOME:
        event.preventDefault();
        first();
        break;
      case END:
        event.preventDefault();
        last();
        break;
    }
    onKeyDown && onKeyDown(event);
  }

  return {
    handleOnKeyDown,
  };
}

export function useRadioSelect(props: RadioSelectProps) {
  const {
    items = [],
    loop = true,
    onSelectItem,
    selectedKey,
    onKeyDown,
    ...rest
  } = props;

  const {handleOnKeyDown} = useRadioKeyboardEvents({
    onKeyDown,
    onSelectItem,
    items,
    selectedKey,
    loop,
  });

  const getItemProps = ({
    index,
    item,
  }: {
    index: number;
    item: RadioSelectItem;
  }) => {
    const {key, label, subtext} = item;
    const selected = selectedKey === item.key;

    return {
      'aria-checked': selected,
      first: index === 0,
      key,
      label,
      last: index === items.length - 1,
      onClick: () => onSelectItem(item.key),
      role: 'radio',
      selected,
      subtext,
      tabIndex: selected ? 0 : -1,
    };
  };

  return {
    ...rest,
    onKeyDown: handleOnKeyDown,
    items,
    role: 'radiogroup',
    getItemProps,
  };
}
